import React, { useState } from "react";
import { auth, db } from "../firebase";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

export default function LoginRegister({ mode = "login" }) {
    const location = useLocation();
    const redirectPath = location.state?.from || "/";
    const isInitialLogin = mode === "login";
    const [isLogin, setIsLogin] = useState(isInitialLogin);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [prenom, setPrenom] = useState("");
    const [nom, setNom] = useState("");
    const [indicatif, setIndicatif] = useState("+228");
    const [numero, setNumero] = useState("");

    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            if (isLogin) {
                await signInWithEmailAndPassword(auth, email, password);
            } else {
                if (password !== confirmPassword) {
                    return setError("Les mots de passe ne correspondent pas.");
                }

                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                await setDoc(doc(db, "users", user.uid), {
                    prenom,
                    nom,
                    email,
                    whatsapp: `${indicatif}${numero}`,
                    role: "visiteur",
                    createdAt: new Date(),
                });
            }

            navigate(redirectPath);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="container py-5">
            {/* Logo centré en haut */}
            <div className="text-center mb-4">
                <NavLink to="/" className="h3 text-primary fw-bold mb-0 text-decoration-none"><img src="/logo192.png" alt="Logo THE BRIDGE" width="120" /></NavLink>
            </div>

            <div className="row">
                {/* Colonne vidéo / texte */}
                <div className="col-md-6 mb-4">
                    <div className="ratio ratio-16x9 mb-3">
                        <iframe
                            src="https://www.youtube.com/embed/#"
                            title="THE BRIDGE,Pourquoi créer un compte"
                            allowFullScreen
                        ></iframe>
                    </div>
                    <h4>{isLogin ? "Bienvenue sur THE BRIDGE" : "Pourquoi créer un compte ?"}</h4>
                    <p>
                        {isLogin
                            ? "Connectez-vous pour accéder à vos véhicules favoris et commander plus facilement."
                            : "Créer un compte vous permet de gérer vos favoris, passer des commandes et recevoir les dernières offres."}
                    </p>
                </div>

                {/* Colonne formulaire */}
                <div className="col-md-6">

                    <h3 className="fw-bold text-center mb-3">{isLogin ? "Connexion" : "Créer un compte"}</h3>
                    {error && <div className="alert alert-danger">{error}</div>}

                    <form onSubmit={handleSubmit}>
                        {!isLogin && (
                            <>
                                <div className="mb-3">
                                    <label>Prénom</label>
                                    <input type="text" className="form-control" value={prenom} onChange={(e) => setPrenom(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label>Nom</label>
                                    <input type="text" className="form-control" value={nom} onChange={(e) => setNom(e.target.value)} required />
                                </div>
                            </>
                        )}

                        <div className="mb-3">
                            <label>Email</label>
                            <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>

                        <div className="mb-3">
                            <label>Mot de passe</label>
                            <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </div>

                        {!isLogin && (
                            <>
                                <div className="mb-3">
                                    <label>Confirmer le mot de passe</label>
                                    <input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                                </div>
                                <div className="mb-3">
                                    <label>Indicatif WhatsApp</label>
                                    <select className="form-select" value={indicatif} onChange={(e) => setIndicatif(e.target.value)}>
                                        <option value="+228">🇹🇬 +228</option>
                                        <option value="+229">🇧🇯 +229</option>
                                        <option value="+225">🇨🇮 +225</option>
                                        <option value="+33">🇫🇷 +33</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label>Numéro WhatsApp</label>
                                    <input type="tel" className="form-control" value={numero} onChange={(e) => setNumero(e.target.value)} required />
                                </div>
                            </>
                        )}

                        <button type="submit" className="btn btn-primary w-100 btn btn-bridge btn-lg">
                            {isLogin ? "Se connecter" : "Créer un compte"}
                        </button>
                        <p className="text-center mt-3">
                            {isLogin ? "Pas encore de compte ?" : "Déjà un compte ?"}{" "}
                            <span
                                onClick={() => setIsLogin(!isLogin)}
                                style={{ cursor: "pointer", color: "blue" }}
                            >
                                {isLogin ? "S'inscrire" : "Se connecter"}
                            </span>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    );
}
